import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { ReviewContainerModel } from '../../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })

export class ReviewService extends BaseApiPublicLoginTemplateService<ReviewContainerModel, ReviewContainerModel, ReviewContainerModel> {

    static readonly REVIEW_SUB_PATH = 'fi/fi-item/reviews/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ReviewService.REVIEW_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ReviewService.REVIEW_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ReviewService.REVIEW_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP
        this.httpClient = http;
    }
}
